import { render, staticRenderFns } from "./DesignList.vue?vue&type=template&id=13524f46&"
import script from "./DesignList.vue?vue&type=script&lang=js&"
export * from "./DesignList.vue?vue&type=script&lang=js&"
import style0 from "./DesignList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports